




































































import Vue from 'vue';
import { ProductAccessClient, ProductAccessPeriod } from '@/assets/src/clients/product_access_client';
import { toNiceDate } from '@/assets/src/utils/date';

import ProductList from '@/components/ProductList.vue';
import SimplePagination from '@/components/misc/SimplePagination.vue';
import Datepicker from 'vuejs-datepicker';

export default Vue.extend({
  name: 'ProductAccessPeriodList',

  components: { ProductList, Datepicker, SimplePagination },

  props: {
    accountGroupId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    pageCount(): number {
      return Math.ceil(this.productAccessPeriods.length / this.itemsPerPage);
    },

    activeProductAccessPeriods(): ProductAccessPeriod[] {
      return this.productAccessPeriods.filter((pap, i) => this.currentPage === Math.floor(i / this.itemsPerPage) + 1);
    },
  },

  methods: {
    toNiceDate,

    expired(dateString: string): boolean {
      return new Date() > new Date(dateString);
    },

    async addProductAccessPeriod(): Promise<void> {
      this.error = '';

      if (this.description === '') {
        this.error = 'You must provide a description';
        return;
      }

      this.startDate.setUTCHours(0, 0, 0);
      this.endDate.setUTCHours(23, 59, 59);

      try {
        await this.productAccessClient.addProductAccessPeriod({
          account_group_id: this.accountGroupId,
          description: this.description,
          product_type: this.productType,
          quantity: this.quantity,
          price: 0,
          currency: 'eur',
          period_start: this.startDate.toISOString(),
          period_end: this.endDate.toISOString(),
        });
      } catch (error) {
        this.error = 'An error occured while adding PAP. Check network console. Error: ' + error;
      }

      await this.fetchProductAccessPeriods();
    },

    async fetchProductAccessPeriods(): Promise<void> {
      try {
        this.productAccessPeriods = await this.productAccessClient.getProductAccessPeriods(this.cognitoID);
      } catch (error) {
        this.error = 'An error occured while fetching PAPs. Check network console. Error: ' + error;
      }
    },

    async deleteProductAccessPeriod(id: number): Promise<void> {
      try {
        await this.productAccessClient.deleteProductAccessPeriod(id);
        await this.fetchProductAccessPeriods();
      } catch (error) {
        this.error = 'An error occured while deleting PAP. Check network console. Error: ' + error;
      }
    },
  },

  mounted() {
    this.cognitoID = this.$route.params.cognito_id;
    this.fetchProductAccessPeriods();
  },

  activated() {
    this.cognitoID = this.$route.params.cognito_id;
    this.fetchProductAccessPeriods();
  },

  data() {
    return {
      cognitoID: '',

      productAccessPeriods: [] as ProductAccessPeriod[],
      productAccessClient: new ProductAccessClient(),
      itemsPerPage: 10,
      currentPage: 1,

      startDate: new Date(),
      endDate: new Date(),
      quantity: 1,
      description: '',
      productType: '',

      error: '',
    };
  },
});
